import { Component, inject } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
	selector: "ic-duplicate-task-dialog",
	templateUrl: "./duplicate-task-dialog.component.html",
	styleUrls: ["./duplicate-task-dialog.component.scss"],
	standalone: false,
})
export class DuplicateTaskDialogComponent {
	data = inject<{
		message: string;
	}>(MAT_DIALOG_DATA);
}
